require('./externalTransferFundStep2.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { withRouter } = require('react-router-dom');
// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('components/commons/OKModal/OKModal');
// @ components
const { BrokerAdvancedSearchExplore } = require('components/broker/brokerAdvancedSearch/brokerAdvancedSearchExplore/brokerAdvancedSearchExplore');
const ExternalTransferFundStep1 = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFundStep1/externalTransferFundStep1');
const { EmptyState } = require('commonsComponents/emptyState');

// @ constants

class ExternalTransferFundStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            filterSettingsOpen: false,
            product: '',
            productName: '',
            showProductLabel: false,
        };
        this.handleSetProduct = this.handleSetProduct.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleCancelSearch = this.handleCancelSearch.bind(this);
        this.handleRedirectNoFundsModal = this.handleRedirectNofundsModal.bind(this);
        this.handleRetry = this.handleRetry.bind(this);

    }

    buildSearchFundModal() {
        const modalContent = (
            <div className="external-transfer-fund-step2__modal-container modal-scroll-container" >
                <BrokerAdvancedSearchExplore
                    isModal
                    onHandleProductSelect={this.props.handleInputSearchProductSelected}
                    isModalFund
                    isExternalFundsTransfer
                    selectedNewFund={this.props.immExternalTransferFund.getIn(['steps', 1, 'selected'])}
                >
                </BrokerAdvancedSearchExplore>
            </div>
        );
        const selectButtonText = formatText("brokerExternalTransferFundStep2-selectButton");
        const cancelButtonText = formatText("brokerExternalTransferFundStep2-cancelButton");
        return (
            <div className="external-transfer-fund-step2__modal-container-wrapper">
                <OKModal
                    content={modalContent}
                    contentOverflow="hidden"
                    footerType="navigation"
                    isOpen={this.state.filterSettingsOpen}
                    onCloseCallback={this.handleCancelSearch}
                    size="regular"
                    primaryButtonText={selectButtonText}
                    onPrimaryButtonClick={this.handleSetProduct}
                    primaryButtonDisabled={!this.props.immExternalTransferFund.getIn(['steps', 1, 'selected', 'label'])}
                    secondaryButtonText={cancelButtonText}
                    onSecondaryButtonClick={this.handleCancelSearch}
                />
            </div>
        );
    }

    handleRedirectNofundsModal() {
        this.props.history.push('/myprofile/broker/general')
    }

    handleSetProduct() {
        const { immExternalTransferFund, handleSetSearchProductSelected, setHasNif } = this.props
        if (immExternalTransferFund.getIn(['steps', 1, 'selected' ,'label'])) {
            handleSetSearchProductSelected();
            setHasNif(immExternalTransferFund.getIn(['steps', 1, 'selected','isin']).substr(0,2) !== 'ES');
        }
        this.setState({
            filterSettingsOpen: false
        });
    }

    handleCancelSearch() {
        this.props.handleResetSearchProductSelected();
        this.handleToggleFilters();
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    handleRetry() {
        const { getStocksContracts, onHandleRetry } = this.props;
        onHandleRetry();
        getStocksContracts();
    }

    buildNoFundsModal(){
        const title = formatText('brokerExternalTransferFundStep1-noFundsModal_title');
        const description = formatText('brokerExternalTransferFundStep1-noFundsModal_description');
        const buttonText = formatText('brokerExternalTransferFundStep1-noFundsModal_buttonText');
        return(
            <OKModal
                title={title}
                isOpen
                description={description}
                footerType="action"
                primaryButtonText={buttonText}
                onPrimaryButtonClick={this.handleRedirectNoFundsModal}
                onCloseCallback={this.handleRedirectNoFundsModal}
                shouldCloseOnOverlayClick={false}
            />
        )
    }

    buildErrorState(productTabTitle) {
        const lostConnectionFirstLine = formatText('broker-lostConnectionFirstLine');
        const retryButton = (
            <OKButton id="btn_accountLastMovements_retry" onClick={this.handleRetry}>
                <FormattedText value="broker-retry" />
            </OKButton>
        );
        return (
            <div customClassName="broker-my-investments">
                <div className="broker-my-investments__title">
                    <span>{productTabTitle}</span>
                </div>
                <EmptyState button={retryButton} primaryText={lostConnectionFirstLine} iconType="nointernet-wealth"/>
            </div>
        );
    }

    render() {
        const {
            immBrokerMyInvestments,
            immExternalTransferFund,
            setInstitutionName,
            setAccount,
            setNif,
            noDestinationFunds,
        } = this.props;
        const searchFundModal = this.buildSearchFundModal();
        let selectedFundLabel;
        if (immExternalTransferFund.getIn(['steps', 1, 'label'])) {
            selectedFundLabel = (
                <div>
                    <FormattedText value="brokerExternalTransferFundStep2-selectedFund" className="external-transfer-fund-step2__selected-fund"/>
                    <div>
                        <span>
                            {immExternalTransferFund.getIn(['steps', 1, 'label'])}
                        </span>
                    </div>
                </div>
            )
        }

        const formOriginFundManager = immExternalTransferFund.getIn(['steps', 1, 'label']) ? (
            <ExternalTransferFundStep1
                immExternalTransferFund={immExternalTransferFund}
                setInstitutionName={setInstitutionName}
                setAccount={setAccount}
                setNif={setNif}
                noDestinationFunds={noDestinationFunds}/>
        ): null;

        let content;

        if (immBrokerMyInvestments.get('isFetching')) {
            content = <LoadingSection />;
        }
        else if (immBrokerMyInvestments.get('fetchSuccess')) {
            const noFundsModal = immBrokerMyInvestments.getIn(['products','funds','stocks']).size === 0 ? this.buildNoFundsModal() : null;

            content = (<div className="external-transfer-fund-step2">
                {noFundsModal}
                {searchFundModal}
                <FormattedText value="brokerExternalTransferFundStep2-title" className="external-transfer-fund-step2__title"/>
                <FormattedText value="brokerExternalTransferFundStep2-subtitle" className="external-transfer-fund-step2__subtitle"/>
                {selectedFundLabel}
                <OKButton modifier="link-complementary" onClick={this.handleToggleFilters}>
                    <FormattedText value="brokerExternalTransferFundStep2-button" />
                </OKButton>
                {formOriginFundManager}
            </div>);
        }
        else {
            content = this.buildErrorState();
        }
        return (content);
    }
}

ExternalTransferFundStep2.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immExternalTransferFund: PropTypes.object.isRequired,
    getStocksContracts:  PropTypes.func.isRequired,
    onHandleRetry: PropTypes.func.isRequired,
    handleInputSearchProductSelected: PropTypes.func.isRequired,
    handleResetSearchProductSelected: PropTypes.func.isRequired,
    handleSetSearchProductSelected: PropTypes.func.isRequired,
    setInstitutionName: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    setNif: PropTypes.func.isRequired,
    setHasNif: PropTypes.func.isRequired,
    noDestinationFunds: PropTypes.bool.isRequired
};


module.exports = withRouter(ExternalTransferFundStep2);
